import { UserRoleEnum } from "../../Enums/UserRoles";

export interface PathApi {
  to: string;
  text: string;
}

const taskListPath = { to: "./task/list", text: "Банк задач" };
const newsListPath = { to: "./news/list", text: "Новости" };
const moduleListPath = {
  to: "./module/list",
  text: "Модули",
};
const userRolesManagePath = {
  to: "./users/update/roles",
  text: "Управление ролями пользователей",
};
const accessCreatePath = {
  to: "./access/create",
  text: "Коды доступа",
};
const resourceListPath = {
  to: "./resource/list",
  text: "Банк ресурсов",
};
const learningPathListPath = {
  to: "./learning_path/list",
  text: "Пути обучения",
};

export const groupPath = {
  to: "./group",
  text: "Группы",
};

const subscriptionPath = {
  to: "./subscription",
  text: "Подписки",
};

export const methodologyPath = {
  to: "./methodology",
  text: "Методика",
};

export interface RoleSectionsApi {
  role: UserRoleEnum;
  sections: PathApi[];
}

export const profileSectionsByRole: RoleSectionsApi[] = [
  {
    role: UserRoleEnum.tutor,
    sections: [groupPath, subscriptionPath, methodologyPath],
  },
  {
    role: UserRoleEnum.taskCreator,
    sections: [taskListPath],
  },
  {
    role: UserRoleEnum.methodologist,
    sections: [newsListPath, taskListPath],
  },
  {
    role: UserRoleEnum.admin,
    sections: [
      newsListPath,
      taskListPath,
      moduleListPath,
      accessCreatePath,
      userRolesManagePath,
      resourceListPath,
      learningPathListPath,
    ],
  },
];
